module.exports = __webpack_public_path__ + "static/media/loader.ede310c9.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/loader.svg
// module id = 577
// module chunks = 20